import { HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MyErrorStateMatcher } from 'src/app/shared/directives/stateMatcher';
import { Responses } from 'src/app/shared/interfaces/responses';
import { Rol } from 'src/app/shared/interfaces/rol';
import { User } from 'src/app/shared/interfaces/user';
import { RolesService } from 'src/app/shared/service/catalogs/roles/roles.service';
import { UsersService } from 'src/app/shared/service/users/users.service';
import { ValidateConfirmPassword } from 'src/app/shared/validators/password-validators';

import { BreakpointObserver } from '@angular/cdk/layout';
import { StepperOrientation } from '@angular/material/stepper';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MenuService } from 'src/app/shared/service/menu/menu.service';
import { RolesPermissionsService } from 'src/app/shared/service/catalogs/rolesPermissions/roles-permissions.service';

@Component({
  selector: 'app-cre-dit-users',
  templateUrl: './cre-dit-users.component.html',
  styleUrls: ['./cre-dit-users.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class CreDitUsersComponent implements OnInit {
  // Se cea un nuevo objeto  de MyErrorStateMatcher,para el manejo de erores en el formulario , Tocado , ensuciado, invalido..
  matcher = new MyErrorStateMatcher();

  titleCard: string = 'Nuevo usuario';

  // Objeto de usuarios
  public user: User;
  // Ocultar/Mostrar contraseña
  public hide: boolean = true;
  // Ocultar/Mostrar confirmar contraseña
  public hide2: boolean = true;
  // Ocultar/Mostrar  contraseña actual
  public hide3: boolean = true;
  public loading: boolean = false;
  // Se crea un array roles de tipo Rol
  public roles: Rol[] = [];
  // Filtro  para los roles
  public filteredRoles!: Rol[];
  // Filtro  para los puestos
  public filteredPuestos!: any[];
  // Ocultar/Mostrar campo de la Firma
  public showRutaFirma: boolean = false;
  // Ocultar/Mostrar campo de lCalibración
  public showCalibration: boolean = false;

  // Ruta de la imagen de perfil
  public imageUrl?: any;
  // Existe la imagen de perfil
  public fileExists: boolean = false;
  // Ruta de la imagen de perfil
  public imageUrlFirma?: any;
  // Existe la imagen  de la Firma
  public fileExistsFirma: boolean = false;
  // Etiqueta del campo de contraseña
  labelContrasena = 'Contraseña';
  // Etiqueta del campo de confirmar contraseña
  labelConfirmarContrasena = 'Confirmar contraseña';

  dynamicWidth = '80%';

  //Orientacion del stepper
  stepperOrientation: Observable<StepperOrientation>;
  // datos del menu
  menuData: any[] = [];

  // abrir el menu
  panelOpenState: boolean = false;

  // Usuario que ha iniciado sesión
  userLoggedIn: number;

  roleForCheckbox: any = {
    Id: 11,
    Nombre: 'Asesor de Venta',
  };
  selectedRoles = [];

  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CreDitUsersComponent>,
    breakpointObserver: BreakpointObserver,
    private toastrService: ToastrService,
    private rolesService: RolesService,
    private usersService: UsersService,
    private menuService: MenuService,
    private rolesPermissionsService: RolesPermissionsService,
  ) {
    this.user = { ...data.user };
    this.userLoggedIn = data.userLoggedIn;
    this.getRoles();
    // this.getPuestos();

    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 800px)')
      .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));

    // menu
    this.menuService.getMenu().subscribe({
      next: (resp) => {
        const data = resp?.data ?? [];

        data.forEach((children: any) => {
          if (children.children?.length > 0) {
            children.children.forEach((subchildren: any) => {
              subchildren.type = subchildren.type.type;
              if (!subchildren.subchild || subchildren.subchild.length === 0) {
                delete subchildren.subchild;
              }
            });
          }
          children.type = children.type.type;
        });

        this.menuData = data;
        this.getModulos(this.menuData);
        if (this.user.Id) {
          this.getPermissionsByUser(this.user.Id, this.user.IdRol);
        }
      },
      error: (error) => {
        this.menuData = [];
      },
    });
  }

  ngOnInit(): void {
    // Si existe el Id del usuario
    if (this.user.Id) {
      this.titleCard = 'Editar Usuario';
      this.labelContrasena = 'Nueva contraseña';
      this.labelConfirmarContrasena = ' Confirmar nueva contrasena';
      // Se llama la funcion resetValidators
      this.resetValidators();
      // El valor del EsCalibrador que trae el usuario es =1 entonces es verdadero
      const valueEsCalibrador = this.user.EsCalibrador == '1' ? true : false;
      // Si el valor RutaImagen es diferente a vacia o diferente a nulo
      if (this.user.RutaImagen != '' || this.user.RutaImagen != null) {
        // Mostramos la imagen de perfil
        this.fileExists = true;
        this.imageUrl = this.user.RutaImagen;
      }
      // MET-505: iba con OR, así que la condición era SIEMPRE verdadera (un
      // valor nulo es distinto de '' y uno vacío es distinto de null) y se
      // marcaba que hay firma aunque no la hubiera.
      if (this.user.FirmaDigital) {
        // Mostramos la imagen de la Firma
        this.fileExistsFirma = true;
        this.imageUrlFirma = this.user.FirmaDigital;
      }

      if (this.user.IdRol == 5 || this.user.RolNombre == 'Laboratorio') {
        // Mostramos el campo de calibracion
        this.showCalibration = true;
        // Si el valor del EsCalibrador que trae el usuario es verdadero
        if (valueEsCalibrador) {
          // Mostramos el campo de la Firma
          this.showRutaFirma = true;
        }
      }
      setTimeout(() => {
        // Esperamos 20 milisegundo para hacer el patchvalue a si es calibrador
        this.usersForm.controls.EsCalibrador.patchValue(valueEsCalibrador);
      }, 20);

      // Realizamos el patchValue al formulario de usuario para editar
      this.usersForm.patchValue(this.user);
    }
    this.filteredRoles = this.roles.filter(
      (role) => role.Id !== this.roleForCheckbox.Id,
    );
  }

  usersForm = this.formBuilder.group(
    {
      Id: [null],
      Guid: [null],
      Nombre: ['', Validators.required],
      ApellidoPaterno: ['', Validators.required],
      ApellidoMaterno: ['', [Validators.required]],
      Nickname: ['', Validators.required],
      Email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      RutaImagen: ['', []],
      Imagen: ['', []],
      IdRol: ['', Validators.required],
      NombreRol: ['', Validators.required],
      RoleSelected: [false],
      SelectedRoleId: [null],
      Telefono: [''],
      Extension: [''],
      FirmaDigital: [''],
      EsCalibrador: [''],
      RutaFirma: [''],
      ImagenFirma: ['', []],
      Contrasena: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{8,30}$/,
          ),
          Validators.minLength(6),
          Validators.maxLength(30),
        ],
      ],
      confirmarContrasena: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{8,30}$/,
          ),
          Validators.minLength(6),
          Validators.maxLength(30),
        ],
      ],
      ContrasenaActual: ['', []],
      Modulos: this.formBuilder.array([]),
      Direccion: [''],
      TelOficinas: [''],
    },
    {
      validators: ValidateConfirmPassword.MatchPassword,
    },
  );

  getModulos(menuData: any): void {
    const Modulos = this.usersForm.get('Modulos') as FormArray;
    for (const modulo of menuData) {
      const permisoFormGroup = this.formBuilder.group({
        IdModulo: [modulo.Id],
        Nombre: [modulo.Nombre],
        CheckedModulo: [false],
        SubModulos: this.getSubModulos(modulo),
      });
      Modulos.push(permisoFormGroup);
    }
    // console.log(Modulos.value)
  }

  getSubModulos(modulo: any): FormArray {
    return this.formBuilder.array(
      modulo.children.map((submodulo: any) => {
        return this.formBuilder.group({
          IdModulo: submodulo.Id,
          Nombre: submodulo.Nombre,
          CheckedSubModulo: false,
        });
      }),
    );
  }

  get permisosModulos(): FormArray {
    return this.usersForm.get('Modulos') as FormArray;
  }

  // Función que obtiene los permisos de los modulos desde la api
  private getPermissionsByUser(IdUsuario: number, IdRol: number): void {
    this.rolesPermissionsService
      .getPermissionsByUser(IdUsuario, IdRol)
      .subscribe({
        next: (response: Responses) => {
          const permissions = response.data;
          const modulosFilter = this.menuData.filter((elemento: any) =>
            permissions.find((elem: any) => elem.IdModulo === elemento.Id),
          );

          for (let i = 0; i < this.permisosModulos.controls.length; i++) {
            const existModulo = modulosFilter.find(
              (elem: any) =>
                elem.Id === this.permisosModulos.controls[i].value.IdModulo,
            );
            const control = this.permisosModulos.at(i).get('CheckedModulo');
            if (existModulo) {
              control?.patchValue(true);
            }
            const submodulos =
              this.permisosModulos.controls[i].value.SubModulos;
            const submodulosFormArray = this.permisosModulos
              .at(i)
              .get('SubModulos') as FormArray;

            const submodulosFilter = this.menuData[i].children.filter(
              (elemento: any) =>
                permissions.find((elem: any) => elem.IdModulo === elemento.Id),
            );

            if (submodulos.length) {
              for (let j = 0; j < submodulos.length; j++) {
                const existSubModulo = submodulosFilter.find(
                  (elem: any) => elem.Id === submodulos[j].IdModulo,
                );
                const controlS = submodulosFormArray
                  .at(j)
                  .get('CheckedSubModulo');
                if (existSubModulo) {
                  controlS?.patchValue(true);
                }
              }
            }
          }
        },
        error: (error: any) => this.toastrService.error('Ha ocurrido un error'),
      });
  }
  public saveUser(): void {
    if (this.usersForm.valid) {
      if (this.user.Id) {
        this.usersForm.addControl(
          'ActualizadoPor',
          this.formBuilder.control(this.userLoggedIn),
        );
        this.usersService.updateUser(this.usersForm.value).subscribe({
          next: (response) => {
            this.closeModal(response);
          },
          error: (err) => {
            this.toastrService.error(err.error.error);
          },
        });
      } else {
        this.usersForm.addControl(
          'CreadoPor',
          this.formBuilder.control(this.userLoggedIn),
        );
        this.usersService.registroUsuarios(this.usersForm.value).subscribe({
          next: (response) => {
            this.closeModal(response);
          },
          error: (err) => {
            this.toastrService.error(err.error.error);
          },
        });
      }
    } else {
      this.toastrService.error('Por favor llena los campos faltantes');
    }

    const formValue = this.usersForm.value;

    if (formValue.RoleSelected) {
      console.log('Role Selected:', this.roleForCheckbox.Nombre);
      formValue.NombreRol = this.roleForCheckbox.Nombre;
      formValue.SelectedRoleId = this.roleForCheckbox.Id;
    } else if (formValue.SelectedRoleId) {
      const selectedRole = this.roles.find(
        (role) => role.Id === formValue.SelectedRoleId,
      );
      console.log(
        'Role Selected from Autocomplete:',
        selectedRole ? selectedRole.Nombre : 'None',
      );
    } else {
      console.log('No Role Selected');
    }
  }

  // Función que concatena el nombre + apellido paterno
  public setUsername() {
    let nombre = this.usersForm.controls.Nombre.value;
    nombre = nombre ? nombre.trim() : '';
    let paternalSurname = this.usersForm.controls.ApellidoPaterno.value;
    paternalSurname = paternalSurname ? paternalSurname.trim() : '';
    let nickname = `${nombre}.${paternalSurname}`;
    this.usersForm.patchValue({
      Nickname: nickname,
    });
  }

  // Función para subir archivo de imagen de Perfil
  onFileSelected(event: any) {
    //Crear una pre visualización de la imagen
    let files = event;
    this.imageUrl = '';
    // Creamos un nuevo formulario
    let formData = new FormData();
    // Añadimos el archivo y el nombre al formulario
    formData.append('myfile', files, files.name);
    // formData.append('type', 'Usuarios');
    // Enviamos el formulario al service
    this.usersService.uploadImage(formData).subscribe({
      next: (event: HttpEvent<any>) => {
        // Checamos el progreso de subida
        if (event.type === HttpEventType.UploadProgress) {
          if (event.total! > 0) {
            (event as any).percent = (event.loaded / event.total!) * 100;
          }
        } else if (event instanceof HttpResponse) {
          // El archivo subido existe = verdadero
          this.fileExists = true;
          // Recibimos la ruta del archivo subido
          this.imageUrl = event.body.data.url;
          // MET-505: esto guardaba la foto en FirmaDigital, que es el campo de
          // la FIRMA. Subir la foto de perfil borraba la firma del usuario (y
          // la foto nunca llegaba a RutaImagen). FirmaDigital lo leen la vista
          // previa de la firma, el correo de cobranza y el de cotizaciones.
          setTimeout(() => {
            this.usersForm.patchValue({ RutaImagen: event.body.data.url });
          }, 1000);
        }
      },
      error: (error) => {},
      complete() {},
    });
  }

  // Función para subir archivo de imagen de la Firma
  onFileSelectedFirma(event: any) {
    //Crear una pre visualización de la imagen
    let files = event;
    this.imageUrlFirma = '';
    // Creamos un nuevo formulario
    let formData = new FormData();
    // Añadimos el archivo y el nombre al formulario
    formData.append('myfile', files, files.name);
    // formData.append('type', 'Usuarios');
    // Enviamos el formulario al service
    this.usersService.uploadImage(formData).subscribe({
      next: (event: HttpEvent<any>) => {
        // Checamos el progreso de subida
        if (event.type === HttpEventType.UploadProgress) {
          if (event.total! > 0) {
            (event as any).percent = (event.loaded / event.total!) * 100;
          }
        } else if (event instanceof HttpResponse) {
          // El archivo subido existe = verdadero
          this.fileExistsFirma = true;
          // Recibimos la ruta del archivo subido
          this.imageUrlFirma = event.body.data.url;
          // Hacemos patchvalue al campo de RutaImagen
          setTimeout(() => {
            this.usersForm.patchValue({ FirmaDigital: event.body.data.url });
          }, 1000);
        }
      },
      error: (error) => {},
      complete() {},
    });
  }

  // Hace setvalue al IdPuestoTrabajo
  // public setPuesto(id : number ): void{
  //   this.usersForm.controls.IdPuestoTrabajo.setValue(id);
  // }
  // Hace setvalue al IdRol
  public setIdRol(id: number): void {
    if (id) {
      this.usersForm.controls.IdRol.setValue(id);

      // Mostrar u ocultar el campo de calibrador según el rol seleccionado
      if (id === 5) {
        // Si el rol es 'Laboratorio'
        this.showCalibration = true;
      } else {
        // Si el rol es diferente a 'Laboratorio'
        this.showCalibration = false;
        this.usersForm.controls.EsCalibrador.patchValue(false);
        this.showRutaFirma = false;
      }

      // Actualizar el control de SelectedRoleId con el ID del rol seleccionado
      this.usersForm.get('SelectedRoleId')?.setValue(id);
    }
  }

  // Función void de si es calibrador
  public isCalibrator(): void {
    this.showRutaFirma = this.usersForm.controls.EsCalibrador.value;
  }
  // Función que obtiene los roles desde la api
  private getRoles(): void {
    this.rolesService.getRoles().subscribe({
      next: (response: Responses) => {
        this.roles = response.data!;
        this.filteredRoles = this.roles;
        if (!this.roles.length) this.toastrService.warning(response.message);
      },
      error: (error: any) => this.toastrService.error('Ha ocurrido un error'),
    });
  }
  // Función que obtiene los puestos desde la api
  // private getPuestos(): void{
  //   this.filteredPuestos = this.dataPuestos;
  // }
  // Función que para cerrar el modal dependiendo el response
  public closeModal(response: Responses): void {
    if (response !== undefined) {
      if (response.success) {
        this.toastrService.success(response.message);
        this.dialogRef.close(true);
      }
    } else {
      this.dialogRef.close(false);
    }
  }

  // Función para cerrar el modal al dar clic en Cancelar
  public close(): void {
    this.dialogRef.close(false);
  }

  // // Función para filtrar los campos de autoacompletados
  public filterData(value: any, type: number): void {
    const filterValue = value.toLowerCase().trim();

    switch (type) {
      case 1:
        // Filtrar puestos
        // this.filteredPuestos = this.dataPuestos.filter(x => x.Nombre.toLowerCase().includes(filterValue) || x.Id == value);
        // if (this.filteredPuestos.length === 0) {
        //   this.toastrService.warning('No existe el puesto');
        // }
        break;
      case 2:
        // Filtrar roles
        if (value != 'Laboratorio') {
          this.showCalibration = false;
          this.usersForm.controls.EsCalibrador.patchValue(false);
          this.showRutaFirma = false;
        }

        // Filtrar roles y excluir "Asesor de venta" de filteredRoles
        this.filteredRoles = this.roles.filter(
          (role) =>
            role.Nombre.toLowerCase().includes(filterValue) &&
            role.Nombre !== 'Asesor de venta',
        );
        if (this.filteredRoles.length === 0) {
          this.toastrService.warning('No existe el rol');
        }
        break;
      default:
        break;
    }
  }

  // Función que resetea los validadores  en el form de editar  usuario,
  private resetValidators(): void {
    // Reseteamos los validores para la contraseña y confirmar contraseña
    this.usersForm.controls.Contrasena.clearValidators();
    this.usersForm.controls.confirmarContrasena.clearValidators();
    // Añadimos validadores a el campo de Contrasena exceptuando el required
    this.usersForm.controls.Contrasena.setValidators([
      Validators.pattern(/^(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{8,30}$/),
      Validators.minLength(6),
      Validators.maxLength(30),
    ]);
    // Añadimos validadores a el campo de confirmarContrasena exceptuando el required
    this.usersForm.controls.confirmarContrasena.setValidators([
      Validators.pattern(/^(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{8,30}$/),
      Validators.minLength(6),
      Validators.maxLength(30),
    ]);
    // Añadimos validadores a el campo de ContrasenaActual exceptuando el required
    this.usersForm.controls.ContrasenaActual.setValidators([
      Validators.pattern(/^(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{8,30}$/),
      Validators.minLength(6),
      Validators.maxLength(30),
    ]);
  }

  get confirmarPassword() {
    return this.usersForm.get('confirmarContrasena');
  }

  get password() {
    return this.usersForm.get('Contrasena');
  }

  get passwordCurrent() {
    return this.usersForm.get('ContrasenaActual');
  }

  // Mensages de error de la contraseña
  getErrorMsjPassword() {
    return this.password?.hasError('required')
      ? 'Contraseña obligatoria'
      : this.password?.hasError('minlength')
        ? 'Debe tener al menos 8 carácteres.'
        : this.password?.hasError('maxlength')
          ? 'Debe tener máximo 30 carácteres.'
          : this.password?.hasError('pattern')
            ? '  Coloque al menos un número, una letra minúscula,una letra mayúscula, y un carácter especial'
            : '';
  }
  // Mensages de error de confirmar contraseña
  getErrorMsjConfirmarPassword() {
    return this.confirmarPassword?.hasError('required')
      ? 'Contraseña obligatoria'
      : this.confirmarPassword?.hasError('minlength')
        ? 'Debe tener al menos 8 carácteres.'
        : this.confirmarPassword?.hasError('maxlength')
          ? 'Debe tener máximo 30 carácteres.'
          : this.confirmarPassword?.hasError('pattern')
            ? '  Coloque al menos un número, una letra minúscula,una letra mayúscula, y un carácter especial'
            : this.confirmarPassword?.hasError('MatchPassword')
              ? '  Las contraseñas no coinciden.'
              : '';
  }
  // Mensages de error de contraseña actual
  getErrorMsjPasswordCurrent() {
    return this.passwordCurrent?.hasError('required')
      ? 'Contraseña obligatoria'
      : this.passwordCurrent?.hasError('minlength')
        ? 'Debe tener al menos 8 carácteres.'
        : this.passwordCurrent?.hasError('maxlength')
          ? 'Debe tener máximo 30 carácteres.'
          : this.passwordCurrent?.hasError('pattern')
            ? '  Coloque al menos un número, una letra minúscula,una letra mayúscula, y un carácter especial'
            : '';
  }
}
